import { ProColumns } from '@ant-design/pro-components';
import { Tabs, Upload, message } from 'antd';
import CustomButton from 'base/ui/components/Button';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { Download, Upload as UploadIcon } from 'base/ui/components/Icons';
import usePartialState from 'hooks/usePartialState';
import { observer } from 'mobx-react';
import { SearchModel } from 'pages/model';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerCRMModel } from 'services/Main/customerSegment_services';
import { customerSegmentPresenter, customerSegmentStore } from 'stores/root_store';
import { MVC_URL, PAGE_SIZE_DEFAULT } from 'utils/constants';
import { checkPermission } from 'utils/permissionHelper';
import * as Icon from 'base/ui/components/Icons';
import { formatNumber } from 'utils/formatHelper';
import { getPlantCode } from 'utils/localStorageHelper';

type CustomerTabProps = {
  customerSegmentationId: string;
};


// THÔNG TIN CHUNG =================================================================================================
function CustomerTab(props: CustomerTabProps) {
  const { customerSegmentationId } = props;
  const { t } = useTranslation();

  const columnsCRM: ProColumns<CustomerCRMModel>[] = [
    // stt
    {
      title: t('zalo-notification.stt'),
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 50,
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Mã CRM
    {
      title: t('segment.ma-crm'),
      dataIndex: 'crmCode',
      key: 'crmCode',
      fixed: 'left',
      width: 90,
      render: (_, record) => {
        return <a target='_blank'
          href={`${MVC_URL}/Customer/Profile/Edit/?id=${record.profileId}&ProfileType=Account`}
          rel="noreferrer" >
          {_}
        </a>
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Mã SAP
    {
      title: t('segment.ma-sap'),
      dataIndex: 'sapCode',
      key: 'sapCode',
      fixed: 'left',
      width: 90,
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Tên
    {
      title: t('segment.ten-kh'),
      dataIndex: 'customerName',
      key: 'customerName',
      width: 300,
      ellipsis: true,
      render: (_, record) => {
        return <a target='_blank'
          href={`${MVC_URL}/Customer/Profile/Edit/?id=${record.profileId}&ProfileType=Account`}
          rel="noreferrer" >
          {_}
        </a>
      },
    },
    //   Địa chỉ
    {
      title: t('segment.dia-chi'),
      dataIndex: 'address',
      key: 'address',
      width: 300,
      ellipsis: true
    },
    // Số điện thoại
    {
      title: t('segment.sdt'),
      dataIndex: 'phone',
      key: 'phone',
      width: 100,
    },
    // Email
    {
      title: t('segment.email'),
      dataIndex: 'email',
      key: 'email',
      width: 180,
      ellipsis: true
    },
    //   Mô tả
    // {
    //   title: t('segment.mo-ta'),
    //   dataIndex: 'description',
    //   key: 'description',
    //   width: 150,
    // },
    // ----------------------------------------------------------------
    // Nhân viên Admin
    {
      title: 'Nhân viên Admin',
      dataIndex: 'customerAdmin',
      width: 150,
      key: 'customerAdmin',
      className: '!rounded-none !py-1',
    },
    // Nhân viên kinh doanh
    {
      title: 'Nhân viên kinh doanh',
      dataIndex: 'customerSales',
      width: 200,
      ellipsis: true,
      key: 'customerSales',
      className: '!rounded-none !py-1',
    },
    // Phòng ban NVKD
    {
      title: 'Phòng ban NVKD',
      dataIndex: 'departmentName',
      width: 200,
      ellipsis: true,
      key: 'departmentName',
      className: '!rounded-none !py-1',
    },
    // Hệ thống showroom (Đếm số lượng)
    {
      title: 'Hệ thống showroom',
      dataIndex: 'quantityShowroom',
      width: 100,
      key: 'quantityShowroom',
      className: '!rounded-none !py-1',
      render: (text) => <div className="!text-right">{text}</div>,
    },
    // Giá trị điểm trưng bày
    {
      title: 'Giá trị điểm trưng bày',
      dataIndex: 'gtdtb',
      width: 120,
      key: 'gtdtb',
      className: '!rounded-none !py-1',
      render: (text, record) => <div className="!text-right">{formatNumber(record.gtdtb, 0)}</div>,
    },
    // Số lượng nhân sự của công ty
    {
      title: 'Số lượng nhân sự của công ty',
      dataIndex: 'quantityEmployee',
      width: 120,
      key: 'quantityEmployee',
      className: '!rounded-none !py-1',
      render: (text, record) => <div className="!text-right">{record.quantityEmployee}</div>,

    },
    // Tỉ lệ lãi gộp
    {
      title: 'Tỉ lệ lãi gộp',
      dataIndex: 'tiLeLaiGop',
      width: 110,
      key: 'tiLeLaiGop',
      className: '!rounded-none !py-1',
      render: (text, record) => <div className="!text-right">{formatNumber(record.tiLeLaiGop, 2)}%</div>,
    },
    // Khu vực (Bắc, Trung, Nam)
    {
      title: 'Khu vực',
      dataIndex: 'area',
      width: 250,
      key: 'area',
      ellipsis: true,
      className: '!rounded-none !py-1',
    },
    // Tỉnh/Thành phố
    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'province',
      width: 150,
      key: 'province',
      className: '!rounded-none !py-1',
    },
    // Quận/Huyện
    {
      title: 'Quận/Huyện',
      dataIndex: 'district',
      width: 150,
      key: 'district',
      className: '!rounded-none !py-1',
    },
    // Doanh số
    {
      title: 'Doanh số',
      dataIndex: 'revenue',
      width: 150,
      key: 'revenue',
      className: '!rounded-none !py-1',
      render: (text, record) => <div className="!text-right">{record.revenue ? formatNumber(record.revenue, 0) : 0}</div>,
    },

    // thêm field ngày 4/11/2025
    // Doanh số gián tiếp
    {
      title: 'Doanh số gián tiếp',
      dataIndex: 'doanhSoGT',
      width: 150,
      key: 'doanhSoGT',
      className: '!rounded-none !py-1',
      render: (text, record) => <div className="!text-right">{record.doanhSoGT ? formatNumber(record.doanhSoGT, 0) : 0}</div>,
    },
    // Doanh số theo công ty mẹ
    {
      title: 'Doanh số theo công ty mẹ',
      dataIndex: 'doanhSoCtyMe',
      width: 150,
      key: 'doanhSoCtyMe',
      className: '!rounded-none !py-1',
      render: (text, record) => <div className="!text-right">{record.doanhSoCtyMe ? formatNumber(record.doanhSoCtyMe, 0) : 0}</div>,
    },


    // Tăng trưởng doanh số (Cùng kỳ)
    {
      title: 'Tăng trưởng doanh số (Cùng kỳ)',
      dataIndex: 'increaseRevenue',
      width: 150,
      key: 'increaseRevenue',
      className: '!rounded-none !py-1',
      render: (text, record) => {
        return (
          <div className="!text-right">{formatNumber(record.increaseRevenue, 2)}%</div>
        )
      }
    },
    // Tăng trưởng doanh số (Kỳ trước)
    {
      title: 'Tăng trưởng doanh số (Kỳ trước)',
      dataIndex: 'increaseRevenuePreviousPeriod',
      width: 150,
      key: 'increaseRevenuePreviousPeriod',
      className: '!rounded-none !py-1',
      render: (text, record) => {
        return (
          <div className="!text-right">{formatNumber(record.increaseRevenuePreviousPeriod, 2)}%</div>
        )
      }
    },
    // Mức tin dùng sản phẩm AC
    {
      title: 'Mức tin dùng sản phẩm AC',
      dataIndex: 'productLevel',
      width: 100,
      key: 'productLevel',
      className: '!rounded-none !py-1',
    },
    // Mức tương tác
    {
      title: 'Mức tương tác',
      dataIndex: 'interaction',
      width: 100,
      key: 'interaction',
      className: '!rounded-none !py-1',
    },
    // Số năm mua hàng
    {
      title: 'Số năm mua hàng',
      dataIndex: 'numberPurchase',
      width: 100,
      key: 'numberPurchase',
      className: '!rounded-none !py-1',
      render: (text) => <div className="!text-right">{text}</div>,
    },
    // Nhóm hàng mua nhiều (SAP)
    {
      title: 'Nhóm hàng mua nhiều (SAP)',
      dataIndex: 'buyingGroupALot',
      width: 250,
      ellipsis: true,
      key: 'buyingGroupALot',
      className: '!rounded-none !py-1',
    },
    // (Số tháng chưa mua hàng) Thời gian chưa mua hàng tiếp theo
    {
      title: 'Số tháng chưa mua hàng (Tính từ đơn hàng gần nhất)',
      dataIndex: 'timeNotPurchased',
      width: 180,
      key: 'timeNotPurchased',
      className: '!rounded-none !py-1',
      render: (text) => <div className="!text-right">{text}</div>,
    },
  ];

  const columnsOutside: ProColumns<CustomerCRMModel>[] = [
    {
      title: t('zalo-notification.stt'),
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 50,
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Tên
    {
      title: t('segment.ten-kh'),
      dataIndex: 'customerName',
      key: 'customerName',
      width: 200,
    },
    // Số điện thoại
    {
      title: t('segment.sdt'),
      dataIndex: 'phone',
      key: 'phone',
      width: 150,
    },
    // Email
    {
      title: t('segment.email'),
      dataIndex: 'email',
      key: 'email',
      width: 200,
    },
  ];

  // phân trang khách hàng crm (KH có trên CRM)
  const [dataPagingCRM, setDataPagingCRM] = useState<SearchModel>({
    type: 'KHCRM',
    customerSegmentationId: customerSegmentationId,
    companyCode: getPlantCode(),
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
  });
  // số record crm
  const [totalCountCRM, setTotalCountCRM] = useState(0);
  // số record khách ngoài (KH import ngoài)
  const [totalCountOutside, setTotalCountOutside] = useState(0);

  const [dataPagingOutside, setDataPagingOutside] = useState<SearchModel>({
    type: 'KHN',
    customerSegmentationId: customerSegmentationId,
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
  });

  const [loadingTable, setLoadingTable] = usePartialState({
    importFile: false
  })


  // ============================================================ STATE ==========================================================
  const [reportState, setReportState] = usePartialState({
    loading: false,
  });

  // data khách hàng có trên crm
  const [dataCustomerCRM, setDataCustomerCRM] = useState<CustomerCRMModel[]>([]);
  // data khách hàng import ngoài
  const [dataCustomerOutside, setDataCustomerOutside] = useState<CustomerCRMModel[]>([]);

  const [downloading, setDownloading] = useState(false);

  // LẤY DATA KH CÓ TRÊN CRM =================================================================================
  const getDataTableCustomerCRM = async (dataSearch: SearchModel) => {
    await customerSegmentPresenter.getCustomerOfCustomerSegment(customerSegmentStore, dataSearch);
    if (customerSegmentStore.customerOfCustomerSegment.isSuccess) {
      setDataCustomerCRM(customerSegmentStore.customerOfCustomerSegment.data);
      setTotalCountCRM(customerSegmentStore.customerOfCustomerSegment.paging?.totalCount || 0);
      return customerSegmentStore.customerOfCustomerSegment.data;
    }
    return [];
  };
  // lấy data table khách ngoài (KH Import ngoài) ============================================================
  const getDataTableCustomerOutside = async (dataSearch: SearchModel) => {
    await customerSegmentPresenter.getCustomerOfCustomerSegment(customerSegmentStore, dataSearch);
    if (customerSegmentStore.customerOfCustomerSegment.isSuccess) {
      setDataCustomerOutside(customerSegmentStore.customerOfCustomerSegment.data);
      setTotalCountOutside(customerSegmentStore.customerOfCustomerSegment.paging?.totalCount || 0);
      return customerSegmentStore.customerOfCustomerSegment.data;
    }
    return [];
  };

  // ================================ LẤY DROPDOWN ===========================================================

  return (
    <div className="mt-3">
      <Tabs
        type="line"
        size={'small'}
        className="[&_.ant-tabs-ink-bar]:!bg-primary"
        items={[
          // KH có trên CRM
          {
            label: t('segment.kh-crm'),
            key: '1',
            children: (
              <div className="mt-3">
                <CustomProTable<CustomerCRMModel>
                  bordered
                  columns={columnsCRM}
                  // handleResize={() => { }}
                  dataSource={dataCustomerCRM}
                  // dataSource={[
                  //   {
                  //     stt: 1,
                  //     id: 'fsdfmdsofds',
                  //     increaseRevenue: -0.3423,
                  //     increaseRevenuePreviousPeriod: -0.4243
                  //   }
                  // ]}
                  request={async (params = {}, sort, filter) => {
                    const data = await getDataTableCustomerCRM({
                      ...dataPagingCRM,
                      paging: {
                        ...dataPagingCRM.paging,
                        orderBy:
                          Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                        orderByDesc:
                          Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                      },
                    });

                    if (Object.values(sort).length) {
                      setDataPagingCRM({
                        ...dataPagingCRM,
                        paging: {
                          ...dataPagingCRM.paging,
                          orderBy:
                            Object.values(sort)[0] === 'ascend'
                              ? `${Object.keys(sort)[0].split(',').pop()}`
                              : undefined,
                          orderByDesc:
                            Object.values(sort)[0] === 'descend'
                              ? `${Object.keys(sort)[0].split(',').pop()}`
                              : undefined,
                        },
                      });
                    }
                    return {
                      data: data,
                      success: customerSegmentStore.customerOfCustomerSegment.isSuccess,
                    };
                  }}
                  toolBarRender={() => [
                    // EXPORT =================================================================
                    <CustomButton
                      loading={reportState.loading}
                      onClick={async () => {
                        setReportState({ loading: true });
                        await customerSegmentPresenter.exportExcel({
                          customerSegmentationId: customerSegmentationId,
                          type: 'KHCRM',
                          companyCode: getPlantCode()
                        })
                        setReportState({ loading: false });
                      }}
                      icon={<Icon.Download className={'!fill-dark'} />}
                    >
                      {t('btn.export')}
                    </CustomButton>,]}

                  rowKey="stt"
                  pagination={{
                    ...tablePagination(dataPagingCRM, setDataPagingCRM),
                    total: totalCountCRM,
                  }}
                  scroll={{ x: 2500, y: 700 }}
                  options={{
                    setting: false,
                    density: false,
                    fullScreen: true,
                    reload: true,
                  }}
                />
              </div>
            ),
          },
          // KH import ngoài
          {
            label: t('segment.kh-ngoai'),
            key: '2',
            children: (
              <div className="mt-3">
                <CustomProTable<CustomerCRMModel>
                  bordered
                  columns={columnsOutside}
                  handleResize={() => { }}
                  rowKey="stt"
                  dataSource={dataCustomerOutside}
                  request={async (params = {}, sort, filter) => {
                    const data = await getDataTableCustomerOutside({
                      ...dataPagingOutside,
                      paging: {
                        ...dataPagingOutside.paging,
                        orderBy:
                          Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                        orderByDesc:
                          Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                      },
                    });

                    if (Object.values(sort).length) {
                      setDataPagingOutside({
                        ...dataPagingOutside,
                        paging: {
                          ...dataPagingOutside.paging,
                          orderBy:
                            Object.values(sort)[0] === 'ascend'
                              ? `${Object.keys(sort)[0].split(',').pop()}`
                              : undefined,
                          orderByDesc:
                            Object.values(sort)[0] === 'descend'
                              ? `${Object.keys(sort)[0].split(',').pop()}`
                              : undefined,
                        },
                      });
                    }
                    return {
                      data: data,
                      success: customerSegmentStore.customerOfCustomerSegment.isSuccess,
                    };
                  }}
                  pagination={{
                    ...tablePagination(dataPagingOutside, setDataPagingOutside),
                    total: totalCountOutside,
                  }}
                  options={{
                    setting: false,
                    density: false,
                    fullScreen: true,
                    reload: true,
                  }}
                  toolBarRender={() => [
                    // EXPORT =================================================================
                    <CustomButton
                      loading={reportState.loading}
                      onClick={async () => {
                        setReportState({ loading: true });
                        await customerSegmentPresenter.exportExcel({
                          customerSegmentationId: customerSegmentationId,
                          type: 'KHN',
                          companyCode: getPlantCode()
                        })
                        setReportState({ loading: false });
                      }}
                      icon={<Icon.Download className={'!fill-dark'} />}
                    >
                      {t('btn.export')}
                    </CustomButton>,
                    <CustomButton
                      loading={downloading}
                      onClick={async () => {
                        setDownloading(true);
                        await customerSegmentPresenter.downloadTemplateExceCustomerOutside();
                        setDownloading(false);
                      }}
                      icon={<Download className="!fill-primary" />}
                    >
                      {t('btn.download-template')}
                    </CustomButton>,
                    <Upload
                      disabled={loadingTable.importFile}
                      // name="FileImport"
                      maxCount={1}
                      // action={BASE_API_URL + '/Segmentation/import-customer-outside'}
                      // headers={{
                      //   Authorization: `Bearer ${getAccessToken()}`,
                      // }}
                      customRequest={async (options) => {


                        const { file, onSuccess, onError } = options;
                        const formData = new FormData();
                        formData.append('FileImport', file);
                        formData.append('CustomerSegmentId', customerSegmentationId);
                        const result = await customerSegmentPresenter.importCustomerOutside(formData);
                        if (result) {
                          if (result.isSuccess) {
                            message.success(result.message);
                            setDataPagingOutside({
                              ...dataPagingOutside,
                              paging: {
                                ...dataPagingOutside.paging,
                                pageIndex: 1,
                              },
                            });
                            setLoadingTable({ importFile: true })

                            await getDataTableCustomerOutside({
                              ...dataPagingOutside,
                              paging: {
                                ...dataPagingOutside.paging,
                                pageIndex: 1,
                              },
                            });
                          } else {
                            message.error(result.message);
                          }

                          setLoadingTable({ importFile: false })

                        }

                      }}
                      showUploadList={false}
                    // onChange={async (info) => {
                    //   if (info.file.status === 'done') {
                    //     message.info(info.file.response.message);
                    //     setDataPagingOutside({
                    //       ...dataPagingOutside,
                    //       paging: {
                    //         ...dataPagingOutside.paging,
                    //         pageIndex: 1,
                    //       },
                    //     });
                    //     await getDataTableCustomerOutside({
                    //       ...dataPagingOutside,
                    //       paging: {
                    //         ...dataPagingOutside.paging,
                    //         pageIndex: 1,
                    //       },
                    //     });
                    //   }
                    // }}
                    >
                      <CustomButton type="primary" icon={<UploadIcon className="!fill-white" />}>
                        <label htmlFor="import">{t('btn.import')}</label>
                      </CustomButton>
                    </Upload>,

                  ]}
                />
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}

export default observer(CustomerTab);
